/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react';

// ประกาศตัวแปรรับค่าจาก env
const API_URL = import.meta.env.VITE_API_URL;

function AllDepartment() {
  const { data, setData } = useDataContext();

  // สร้างตัวแปรกันยิงซ้ำ (Protection Flag)
  const hasFetched = useRef(false);

  useEffect(() => {
    // -----------------------------------------------------------
    // ✅ เช็คว่ามีข้อมูล allCountry ใน Context หรือยัง?
    // -----------------------------------------------------------
    if (data?.allCountry && data.allCountry.length > 0) {
      return;
    }

    // -----------------------------------------------------------
    // ✅ เช็คว่า Component นี้เคยสั่งยิงไปแล้วหรือยัง?
    // -----------------------------------------------------------
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;

      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      try {
        // ✅ ใช้ API_URL แทน Hardcode URL
        const response = await fetch(`${API_URL}/countries`, requestOptions);
        const result = await response.json();
        
        setData(prevData => ({
            ...prevData, 
            allCountry: result.data 
        }));
      } catch (error) {
        console.error("Error fetching countries:", error);
        hasFetched.current = false;
      }
    };

    fetchData();

  }, []); 

  return null;
}

export default AllDepartment;
